import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "roles";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const NEW_ROLE = {
    Id: 0,
    Name: "",
    Permissions: 0,
    Description: "",
    CountPermissions: 0,
    CheckedPermissions: []
};
export const ROLE_SERVER_IGNORED_FIELDS = ["CountPermissions", "CheckedPermissions"];
